import React from 'react';
import MenuItem from './MenuItem';

const MenuItems = ({menuItems = [], disabled = false, onClick = () => { } }) => {
    return (
        <div className="menuItems">
            {menuItems.map((menuItem) =>
                <MenuItem
                    key={'mi_' + menuItem.id + '-' + menuItem.productId}
                    menuItem={menuItem}
                    disabled={disabled}
                    onClick={onClick}
                />
            ) }
        </div>
    );
}

export default MenuItems;



// WEBPACK FOOTER //
// ./app/components/Menu/MenuItems.jsx